import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { comparisons } from '../../data/websites';
export function OldVsLiving() {
  return <section aria-labelledby="old-vs-living" className="bg-gray-50 px-[clamp(1rem,4vw,6rem)] py-20 lg:py-28" data-id="element-994" data-mp="srsrdvtfe3u5">
      <h2 id="old-vs-living" className="max-w-[24ch] text-[clamp(2rem,3vw,3.5rem)] font-extrabold leading-tight tracking-tight text-brand-black" data-id="element-995" data-mp="17gyp1fcm7lzx">
        The old way vs. a <span className="text-brand-red" data-id="element-996" data-mp="1gdpgtfk4weop">Living Website</span>
      </h2>

      <div className="mt-12 overflow-hidden rounded-xl border border-gray-200" data-id="element-997" data-mp="1bffmf768hi45">
        <div className="hidden md:grid md:grid-cols-2" data-id="element-998" data-mp="1qe9igjbkfl7g">
          <p className="bg-white px-8 py-5 text-sm font-bold uppercase tracking-[0.14em] text-brand-gray" data-id="element-999" data-mp="1qbncgo4bpdrc">The old way</p>
          <p className="bg-brand-black px-8 py-5 text-sm font-bold uppercase tracking-[0.14em] text-brand-red" data-id="element-1000" data-mp="3s532pjwi0qls">
            A Living Website
          </p>
        </div>
        {comparisons.map(row => <div key={row.old} className="grid border-t border-gray-200 first:border-t-0 md:grid-cols-2 md:first:border-t" data-id="element-1001" data-mp="4i00yvchkblj">
            <div className="flex items-start gap-3 bg-white px-6 py-5 sm:px-8 md:py-6" data-id="element-1002" data-mp="8kd55fbl41g7">
              <XIcon className="mt-1 h-5 w-5 flex-shrink-0 text-brand-gray" aria-hidden="true" data-id="element-1003" data-mp="di69s3x8oned" />
              <p className="text-[clamp(1rem,1.1vw,1.25rem)] text-gray-500" data-id="element-1004" data-mp="i9o80k7vo9vn">
                <span className="sr-only" data-id="element-1005" data-mp="n87y8wti87tt">The old way: </span>
                {row.old}
              </p>
            </div>
            <div className="flex items-start gap-3 bg-brand-black px-6 py-5 sm:px-8 md:border-l md:border-white/10 md:py-6" data-id="element-1006" data-mp="s6j8h8npokck">
              <CheckIcon className="mt-1 h-5 w-5 flex-shrink-0 text-brand-red" strokeWidth={3} aria-hidden="true" data-id="element-1007" data-mp="wa7fnq8fldxa" />
              <p className="text-[clamp(1rem,1.1vw,1.25rem)] font-semibold text-white" data-id="element-1008" data-mp="1177lq15a6goe">
                <span className="sr-only" data-id="element-1009" data-mp="2y1u0tb5n6elu">A Living Website: </span>
                {row.living}
              </p>
            </div>
          </div>)}
      </div>
    </section>;
}